// StaggingBaseURLS
// const baseURL = process.env.REACT_APP_API_ENDPOINT;
// const baseURL = process.env.REACT_APP_API_AWS_ENDPOINT;

// LocalBaseURL
const baseURL = process.env.REACT_APP_BASE_URL;

const endPoints = {
  /*********************** Auth End Points Start *************************/

  // Register
  register: `${baseURL}/auth/register`,

  // Login User
  login: `${baseURL}/auth/login`,

  // Resend Email
  resendEmail: `${baseURL}/auth/resend-link`,

  // Forget Password
  forgetPassword: `${baseURL}/auth/forgot-password`,

  // Reset Password
  resetPassword: `${baseURL}/auth/change-password`,

  // Suspend User Account
  suspendUser: `${baseURL}/auth/suspend-account`,

  // Suspend User Account
  unsuspendUser: `${baseURL}/auth/unsuspend-account`,

  // Delete User
  deleteUser: `${baseURL}/auth/delete-account`,

  // Stripe Link User
  stripeLink: `${baseURL}/stripe/admin/create-link`,

  // Check User Availability
  userAvailability: `${baseURL}/availability`,

  /*********************** Auth End Points End *************************/

  /*********************** Dashboard End Points Start *************************/

  // All User Listing
  usersListing: `${baseURL}/auth/all-users`,

  // User Details
  userDetails: `${baseURL}/auth/user-details`,

  // Update Profile
  updateProfile: `${baseURL}/admin/update-user`,

  // All Services Listing
  allServicesListing: `${baseURL}/pre-defined-service`,

  // All Salons Listing
  allSalonsListing: `${baseURL}/salon`,

  // All Bookings Listing
  allBookingsListing: `${baseURL}/booking/all`,

  // Booking Link User
  bookingLink: `${baseURL}/booking/link`,

  // Booking Link User
  userBooking: `${baseURL}/admin/booking/list`,

  // Update Service
  updateUserService: `${baseURL}/admin/update-service`,

  // Profile
  profile: `${baseURL}/profile`

  /*********************** Dashboard End Points Ends *************************/
};

export default endPoints;
